import React from "react"
import AuthorizedSignatures from "../Services/Console/components/AuthorizedSignatures/Index"

function AuthorizedSignaturesPage(props) {
  return (
    <div>
      <AuthorizedSignatures />
    </div>
  )
}

export default AuthorizedSignaturesPage
